import * as OrderableTypes from "@/constants/orderable-types";
import * as CalendarFormats from "../constants/calendar-formats";
import * as NewsletterTypes from "../constants/newsletter-types";
import * as SizeTypes from "../constants/size-types";
import * as Getters from "./constants/getters";

export default {
    layout(state, getters) {
        return state.layout;
    },
    navPos(state, getters) {
        return state.layout.navPos;
    },
    toolbar(state, getters) {
        return state.layout.toolbar;
    },
    footer(state, getters) {
        return state.layout.footer;
    },
    boxed(state, getters) {
        return state.layout.boxed;
    },
    roundedCorners(state, getters) {
        return state.layout.roundedCorners;
    },
    viewAnimation(state, getters) {
        return state.layout.viewAnimation;
    },
    isLogged(state, getters) {
        return state.logged;
    },
    splashScreen(state, getters) {
        return state.splashScreen;
    },
    [Getters.GET_LOGO](state, getters) {
        let default_logo = "/images/logo2023.png";
        if (state.current_corporation) {
            return _.get(state.current_corporation, "logo.url", default_logo);
        }
        if (state.current_community) {
            return _.get(
                state.current_community,
                "formatted_logo.url",
                default_logo
            );
        }
        return default_logo;
    },
    [Getters.GET_UNREAD_NOTIFICATIONS](state, getters) {
        return state.notifications.data.filter((item) => {
            return !item.read_at;
        });
    },
    [Getters.CURRENT_MONTH](state, getters) {
        if (!state.current_community) {
            return null;
        }
        return window.moment([
            state.current_community.current_month.year,
            state.current_community.current_month.month - 1
        ]);
    },
    [Getters.CALENDAR_ENABLED](state) {
        return _.get(state.current_community, "has_calendar", false);
    },
    [Getters.WEEKLY_CALENDAR_ENABLED](state) {
        return _.get(state.current_community, "has_weekly_calendar", false);
    },
    [Getters.NEWSLETTER_ENABLED](state) {
        return _.get(state.current_community, "has_newsletter", false);
    },
    [Getters.AVAILABLE_LOCATIONS](state, getters) {
        if (!state.current_community) {
            return [];
        }
        return _.filter(state.current_community.locations.data, (location) => {
            return (
                !location.start_date ||
                getters[Getters.CURRENT_MONTH].isSameOrAfter(
                    window.moment(location.start_date)
                )
            );
        });
    },
    [Getters.NEWSLETTER_AVAILABLE](state, getters) {
        if (!state.current_community) {
            return false;
        }
        return (
            !state.current_community.newsletter_start ||
            getters[Getters.CURRENT_MONTH].isSameOrAfter(
                window.moment(state.current_community.newsletter_start)
            )
        );
    },
    [Getters.FLAT_SIZES](state) {
        return _.filter(state.sizes.data, {
            type: SizeTypes.FLAT
        });
    },
    [Getters.POSTER_SIZES](state) {
        return _.filter(state.sizes.data, {
            type: SizeTypes.POSTER
        });
    },
    [Getters.WEEKLY_CALENDAR_AVAILABLE_SIZES](state) {
        return state.sizes.data.filter((size) =>
            _.includes(
                state.config.settings.weekly_calendar.available_sizes,
                size.id
            )
        );
    },
    [Getters.WEEKLY_CALENDAR_AVAILABLE_FLAT_SIZES](state, getters) {
        return _.filter(getters[Getters.WEEKLY_CALENDAR_AVAILABLE_SIZES], {
            type: SizeTypes.FLAT
        });
    },
    [Getters.WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES](state, getters) {
        return _.filter(getters[Getters.WEEKLY_CALENDAR_AVAILABLE_SIZES], {
            type: SizeTypes.POSTER
        });
    },
    [Getters.WEEKLY_CALENDAR_LOCATIONS](state) {
        if (!state.current_community) {
            return [];
        }
        return state.current_community.locations.data.filter(
            (i) => i.calendar_format === CalendarFormats.WEEKLY
        );
    },
    [Getters.MONTHLY_CALENDAR_LOCATIONS](state) {
        if (!state.current_community) {
            return [];
        }
        return state.current_community.locations.data.filter(
            (i) => i.calendar_format === CalendarFormats.MONTHLY
        );
    },
    [Getters.NEWSLETTER_REQUIRES_QUANTITY](state, getters) {
        if (!state.current_community) {
            return false;
        }
        switch (state.current_community.newsletter_type_id) {
            case NewsletterTypes.SIMPLY_SIX:
            case NewsletterTypes.READERS_DELIGHT:
                return !getters[Getters.CALENDAR_ENABLED];
        }
        return [
            NewsletterTypes.BASIC_COMBO,
            NewsletterTypes.FLEX_FOUR
        ].includes(state.current_community.newsletter_type_id);
    },
    [Getters.NEWSLETTER_REQUIRES_COLOR_TYPE](state) {
        if (!state.current_community) {
            return false;
        }
        return [NewsletterTypes.FLEX_FOUR].includes(
            state.current_community.newsletter_type_id
        );
    },
    [Getters.NEWSLETTER_QUANTITY_OPTIONS](state) {
        if (!state.current_community || !state.cart.calendar_quantity) {
            return false;
        }
        let max = 0;
        switch (state.current_community.newsletter_type_id) {
            case NewsletterTypes.BASIC_COMBO:
                max = state.cart.calendar_quantity_11_17;
                return state.config.settings.pricing.quantities.calendars.flats.filter(
                    (item) => item <= max
                );
            case NewsletterTypes.FLEX_FOUR:
                return state.config.settings.pricing.quantities.calendars.flats;
            case NewsletterTypes.SIMPLY_SIX:
            case NewsletterTypes.READERS_DELIGHT:
                max = state.cart.calendar_quantity_11_17;
                return state.config.settings.pricing.quantities.calendars.flats.filter(
                    (item) => item == max
                );
        }
        return state.config.settings.pricing.quantities.calendars.flats;
    },
    //getters for calendar quatity options based on newsletter type and quantity
    [Getters.CALENDAR_QUANTITY_OPTIONS](state) {
        return state.config.settings.pricing.quantities.calendars.flats;
        // if (
        //     !state.current_community ||
        //     !state.cart.calculated_newsletter_quantity
        // ) {
        //     return state.config.settings.pricing.quantities.calendars.flats;
        // }
        // let min = 0;
        // switch (state.current_community.newsletter_type_id) {
        //     case NewsletterTypes.BASIC_COMBO:
        //         min = state.cart.calculated_newsletter_quantity;
        //         return state.config.settings.pricing.quantities.calendars.flats.filter(
        //             (item) => item >= min
        //         );
        //     case NewsletterTypes.FLEX_FOUR:
        //         return state.config.settings.pricing.quantities.calendars.flats;
        //     case NewsletterTypes.SIMPLY_SIX:
        //     case NewsletterTypes.READERS_DELIGHT:
        //         min = state.cart.calculated_newsletter_quantity;
        //         return state.config.settings.pricing.quantities.calendars.flats.filter(
        //             (item) => item == min
        //         );
        // }
        // return state.config.settings.pricing.quantities.calendars.flats;
    },
    [Getters.REQUIRES_SHIPPING_RATE](state) {
        let comm = state.current_community;
        if (!comm) {
            return false;
        }
        if (comm.corporation) {
            return !comm.corporation.has_ups_account;
        }
        return !comm.has_ups_account;
    },
    [Getters.CALENDAR_DIGITAL_FILES](state) {
        return _.values(
            _.filter(state.digital_files.data, {
                orderable_type: OrderableTypes.CALENDAR
            })
        );
    },
    [Getters.NEWSLETTER_DIGITAL_FILES](state) {
        return _.values(
            _.filter(state.digital_files.data, {
                orderable_type: OrderableTypes.NEWSLETTER
            })
        );
    },
    [Getters.BRAND_COLOR](state) {
        return state.config.app.brand_color;
    },
    [Getters.DEFAULT_BRAND_COLOR](state) {
        return state.config.app.default_brand_color;
    },
    // Safe getter for user roles
    userRoles: (state) => {
        return state.user && state.user.roles ? state.user.roles : [];
    },

    // Helper to check if user has a specific role
    hasRole: (state) => (roleName) => {
        if (!state.user || !state.user.roles) {
            return false;
        }
        return state.user.roles.some((role) => role.role === roleName);
    },

    // Helper to check if user has any of the specified roles
    hasAnyRole: (state) => (roleNames) => {
        if (!state.user || !state.user.roles) {
            return false;
        }
        return state.user.roles.some((role) => roleNames.includes(role.role));
    }
};
